import pbdqRoutes from '../pbdqRoutes';

export const PBDQ_SOLUTIONS = [
    {
        id: 'cos-assessments',
        index: '01',
        tabIndex: 0,
        category: 'For governments and organizations',
        shortTitle: 'Child Online Safety (COS) Assessments',
        title: 'Child Online Safety (COS) Assessments',
        subtitle: 'Measure your country’s child online safety',
        description: 'See where your country stands and where to act — across children, government, families, schools, and platforms — benchmarked against 100+ countries through the Child Online Safety Index (COSI).',
        to: pbdqRoutes.cosAssessments,
        features: [
            'Six assessments covering children, governments, parents, teachers, school leaders, and ed-tech providers',
            'Six dashboards available for countries, school networks, schools, classes, students, and DQ Pros',
            'Feeds the COSI — the global benchmark for child online protection',
        ],
        comingSoon: 'Parent, Teacher, School Leader and Ed-Tech assessments.',
    },
    {
        id: 'school-cos-readiness',
        index: '02',
        tabIndex: 1,
        category: 'For schools and school networks',
        shortTitle: 'School Child Online Safety (COS) Readiness',
        title: 'School Child Online Safety (COS) Readiness',
        subtitle: 'Get your schools ready for child online safety',
        description: 'Keep every student safer online — from a clear read of where they stand, to the programs that close the gaps, to the growth measured over time.',
        price: 'From $4.20 / learner / yr',
        to: pbdqRoutes.schoolCosReadiness,
        features: [
            'Baseline assessment for every student, by class and by school',
            'Teachers build their own programs — no curriculum expertise needed',
            'Embedded progress checks evidence real growth, not attendance',
        ],
    },
    {
        id: 'learn-creator',
        index: '03',
        tabIndex: 2,
        category: 'For schools and school networks',
        shortTitle: 'LearnCreator',
        title: 'LearnCreator',
        subtitle: 'Grow AI-digital literacy across your schools',
        description: 'Give teachers the ability to teach AI-digital literacy without any prior experience — inside the subjects they already teach, aligned to 1,000+ national and international frameworks, with the impact measured.',
        price: 'From $3.20 / learner / yr',
        to: pbdqRoutes.learnCreator,
        features: [
            'A complete program with assessment built in, generated in minutes',
            'Standalone course, or woven into existing subjects',
            'Unlimited creator accounts, always included',
        ],
    },
    {
        id: 'workforce-ai-readiness',
        index: '04',
        tabIndex: 3,
        category: 'For companies',
        shortTitle: 'Workforce AI Readiness',
        title: 'Workforce AI Readiness',
        subtitle: 'Build AI-digital capacity for your workforce',
        description: 'Turn AI spending into measurable productivity. Set what AI capability means for every role, measure where each employee stands, and track the improvement on one executive dashboard.',
        price: 'Priced by workforce size',
        to: pbdqRoutes.workforceAiReadiness,
        features: [
            'A shared framework defining the capacity each role needs',
            'Every employee measured, then re-measured, against the framework',
            'Targeted upskilling programs generated from the gaps found',
        ],
    },
    {
        id: 'program-validation',
        index: '05',
        tabIndex: 4,
        category: 'For program providers',
        shortTitle: 'Program Validation',
        title: 'Program Validation',
        subtitle: 'Validate quality. Prove impact. Scale with confidence.',
        description: 'Validate your learning program against global standards and measure its real-world impact. Combine independent DQ Stars validation with pre- and post-program assessment to strengthen credibility with funders, regulators and buyers.',
        to: pbdqRoutes.programValidation,
        features: [
            'Independent validation against globally recognized standards',
            'DQ Stars rating and certification mark awarded where earned',
            'Pre- and post-program impact measurement for 1,000 participants',
        ],
    },
];

export const PBDQ_SOLUTIONS_CONFIG = [
    {
        num: '01',
        bar: '#68C3EE',
        tint: '#E1F0F9',
        ink: '#1F5F86',
        icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M12 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z M7.5 17.5c1-2 2.5-3 4.5-3s3.5 1 4.5 3',
    },
    {
        num: '02',
        bar: '#BCD253',
        tint: '#EDF2D5',
        ink: '#4E6A12',
        icon: 'M3 21h18 M5 21V9l7-5 7 5v12 M9 21v-6h6v6 M12 9.5h.01',
    },
    {
        num: '03',
        bar: '#EDB459',
        tint: '#FAEDDA',
        ink: '#8A5A10',
        icon: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20 M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z M9 7h7 M9 11h5',
    },
    {
        num: '04',
        bar: '#ED6628',
        tint: '#FBEDE4',
        ink: '#A63C0C',
        icon: 'M3 7h18v13H3z M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2 M3 13h18',
    },
    {
        num: '05',
        bar: '#B9316D',
        tint: '#F6E5F0',
        ink: '#8E1F55',
        icon: 'M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12z M8.2 13.9 7 22l5-3 5 3-1.2-8.1',
    },
];
